import { Color } from '../../../../../modules/products/product.types.v2';

export const COLOR_DOT_SIZE = 18;
export const COLOR_DOT_GAP = 4;
const COLOR_COUNTER_WIDTH = 20;

interface OrderColorsWithSelectedFirstParams {
  allColors: Omit<Color, 'code'>[];
  selectedColor?: Omit<Color, 'code'>;
}

export const orderColorsWithSelectedFirst = ({
  allColors,
  selectedColor,
}: OrderColorsWithSelectedFirstParams): Omit<Color, 'code'>[] => {
  if (!selectedColor) {
    return allColors;
  }

  return [selectedColor, ...allColors.filter((color) => color.id !== selectedColor.id)];
};

interface GetVisibleColorsCountParams {
  containerWidth: number;
  totalColors: number;
}

const fitCount = (width: number): number =>
  Math.max(0, Math.floor((width + COLOR_DOT_GAP) / (COLOR_DOT_SIZE + COLOR_DOT_GAP)));

export const getVisibleColorsCount = ({
  containerWidth,
  totalColors,
}: GetVisibleColorsCountParams): number => {
  if (containerWidth <= 0 || totalColors <= 0) {
    return 0;
  }

  const fitsWithoutCounter = fitCount(containerWidth);
  if (totalColors <= fitsWithoutCounter) {
    return totalColors;
  }

  const fitsWithCounter = fitCount(containerWidth - COLOR_COUNTER_WIDTH - COLOR_DOT_GAP);
  return Math.max(1, fitsWithCounter);
};
